export default __webpack_public_path__ + "static/media/mammoth.bff84f3e.jpg";